import styled from 'styled-components';
const ItemWrapper = styled.li`
    margin:${({ theme }) => theme.Spacing.spacing3x};
    list-style-type: none;
`;

export default ItemWrapper;
